// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { TCApiGatewayControllersAccountModelsSharedAddressAccountDataModel } from './tCApiGatewayControllersAccountModelsSharedAddressAccountDataModel.js';
import type { TCApiGatewayControllersAccountModelsSharedAddressPatientDataModel } from './tCApiGatewayControllersAccountModelsSharedAddressPatientDataModel.js';
import type { TCApiGatewayControllersAccountModelsSharedContactAccountDataModel } from './tCApiGatewayControllersAccountModelsSharedContactAccountDataModel.js';
import type { TCApiGatewayControllersAccountModelsSharedEmailAddressPatientDataModel } from './tCApiGatewayControllersAccountModelsSharedEmailAddressPatientDataModel.js';
import type { TCApiGatewayControllersAccountModelsSharedPhoneDataModel } from './tCApiGatewayControllersAccountModelsSharedPhoneDataModel.js';
import type { TCApiGatewayServiceClientsEnumsBasicEnrollmentEthnicity } from './tCApiGatewayServiceClientsEnumsBasicEnrollmentEthnicity.js';
import type { TCApiGatewayServiceClientsEnumsBasicEnrollmentRace } from './tCApiGatewayServiceClientsEnumsBasicEnrollmentRace.js';
import type { TCApiGatewayServiceClientsEnumsGender } from './tCApiGatewayServiceClientsEnumsGender.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCApiGatewayControllersAccountModelsPatientUpSearchRequestModel {
    'accountId'?: number | null;
    'firstName'?: string | null;
    'middleName'?: string | null;
    'lastName'?: string | null;
    'suffix'?: string | null;
    'nickname'?: string | null;
    'dateOfBirth'?: Moment | null;
    'gender'?: TCApiGatewayServiceClientsEnumsGender;
    'primaryLanguageId'?: number | null;
    'isUsResident'?: boolean | null;
    'householdSize'?: number | null;
    'raceCode'?: TCApiGatewayServiceClientsEnumsBasicEnrollmentRace;
    'ethnicityCode'?: TCApiGatewayServiceClientsEnumsBasicEnrollmentEthnicity;
    'addresses'?: Array<TCApiGatewayControllersAccountModelsSharedAddressPatientDataModel> | null;
    'shippingAddresses'?: Array<TCApiGatewayControllersAccountModelsSharedAddressAccountDataModel> | null;
    'emailAddresses'?: Array<TCApiGatewayControllersAccountModelsSharedEmailAddressPatientDataModel> | null;
    'contacts'?: Array<TCApiGatewayControllersAccountModelsSharedContactAccountDataModel> | null;
    'phoneNumbers'?: Array<TCApiGatewayControllersAccountModelsSharedPhoneDataModel> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCApiGatewayControllersAccountModelsPatientUpSearchRequestModel>> = [
        {
            "name":     "accountId",
            "baseName": "accountId",
            "type":     "number"
        },
        {
            "name":     "firstName",
            "baseName": "firstName",
            "type":     "string"
        },
        {
            "name":     "middleName",
            "baseName": "middleName",
            "type":     "string"
        },
        {
            "name":     "lastName",
            "baseName": "lastName",
            "type":     "string"
        },
        {
            "name":     "suffix",
            "baseName": "suffix",
            "type":     "string"
        },
        {
            "name":     "nickname",
            "baseName": "nickname",
            "type":     "string"
        },
        {
            "name":     "dateOfBirth",
            "baseName": "dateOfBirth",
            "type":     "Date"
        },
        {
            "name":     "gender",
            "baseName": "gender",
            "type":     "TCApiGatewayServiceClientsEnumsGender"
        },
        {
            "name":     "primaryLanguageId",
            "baseName": "primaryLanguageId",
            "type":     "number"
        },
        {
            "name":     "isUsResident",
            "baseName": "isUsResident",
            "type":     "boolean"
        },
        {
            "name":     "householdSize",
            "baseName": "householdSize",
            "type":     "number"
        },
        {
            "name":     "raceCode",
            "baseName": "raceCode",
            "type":     "TCApiGatewayServiceClientsEnumsBasicEnrollmentRace"
        },
        {
            "name":     "ethnicityCode",
            "baseName": "ethnicityCode",
            "type":     "TCApiGatewayServiceClientsEnumsBasicEnrollmentEthnicity"
        },
        {
            "name":     "addresses",
            "baseName": "addresses",
            "type":     "Array<TCApiGatewayControllersAccountModelsSharedAddressPatientDataModel>"
        },
        {
            "name":     "shippingAddresses",
            "baseName": "shippingAddresses",
            "type":     "Array<TCApiGatewayControllersAccountModelsSharedAddressAccountDataModel>"
        },
        {
            "name":     "emailAddresses",
            "baseName": "emailAddresses",
            "type":     "Array<TCApiGatewayControllersAccountModelsSharedEmailAddressPatientDataModel>"
        },
        {
            "name":     "contacts",
            "baseName": "contacts",
            "type":     "Array<TCApiGatewayControllersAccountModelsSharedContactAccountDataModel>"
        },
        {
            "name":     "phoneNumbers",
            "baseName": "phoneNumbers",
            "type":     "Array<TCApiGatewayControllersAccountModelsSharedPhoneDataModel>"
        },
    ];

    static getAttributeTypeMap() {
        return TCApiGatewayControllersAccountModelsPatientUpSearchRequestModel.attributeTypeMap;
    }
}
